import { ErrorResponse } from '~/services/auth-api';
import { requests } from '~/services/orca-api/base';
import { ROLES, PENDING_SIGNUP_STATUS } from '~/services/orca-api/constants';
import { routes } from '~/services/orca-api/constants/routes';
import { ChangePermissionsRequest } from '~/services/orca-api/types/BrandUsers/ChangePermissionsRequest';
import { CreateRequest } from '~/services/orca-api/types/BrandUsers/CreateRequest';
import { CreateResponse } from '~/services/orca-api/types/BrandUsers/CreateResponse';
import { ListPayload } from '~/services/orca-api/types/BrandUsers/ListPayload';
import {
  ListResponse,
  ListResponseBrands,
} from '~/services/orca-api/types/BrandUsers/ListResponse';
import { ResponseData } from '~/services/orca-api/types/BrandUsers/ListResponseData';
import { PendingSignupRequest } from '~/services/orca-api/types/BrandUsers/PendingSignupRequest';
import { PendingSignupResponse } from '~/services/orca-api/types/BrandUsers/PendingSignupResponse';
import { ResponseBrands } from '~/services/orca-api/types/BrandUsers/ResponseBrands';
import { ValidateRequest } from '~/services/orca-api/types/BrandUsers/ValidateRequest';
import { ValidateResponse } from '~/services/orca-api/types/BrandUsers/ValidateResponse';
import { ValidateSignupTokenRequest } from '~/services/orca-api/types/BrandUsers/ValidateSignupTokenRequest';
import { ValidateSignupTokenResponse } from '~/services/orca-api/types/BrandUsers/ValidateSignupTokenResponse';

export const OrcaApi = {
  brandUsers: {
    create: (payload: CreateRequest) =>
      requests.post<CreateResponse, CreateRequest>(
        routes.brandUsersAccess.access,
        payload
      ),
    list: (listParams: ListPayload) => {
      let queryParams = listParams ? `?page=${listParams.page}` : '';
      return requests.get<ListResponse>(
        `${routes.brandUsersAccess.accessList}/${listParams.brandId}${queryParams}`
      );
    },
    delete: (brandUserAccessId: string) =>
      requests.delete<{}>(
        `${routes.brandUsersAccess.access}/${brandUserAccessId}`
      ),
    changePermissions: (payload: ChangePermissionsRequest) =>
      requests.patch<{}>(
        `${routes.brandUsersAccess.changePermissions}/${payload.brandUserAccessId}`,
        payload
      ),
    pendingSignup: (pendingSignupParams: PendingSignupRequest) => {
      let queryParams = pendingSignupParams
        ? `?email=${encodeURIComponent(pendingSignupParams.email)}`
        : '';
      return requests.get<PendingSignupResponse>(
        `${routes.brandUsers.pendingSignup}${queryParams}`
      );
    },
    validateSignupToken: (
      payload: ValidateSignupTokenRequest
    ): Promise<ValidateSignupTokenResponse> =>
      requests.get<ValidateSignupTokenResponse>(
        routes.brandUsers.validateSignupToken,
        payload
      ) as Promise<ValidateSignupTokenResponse>,
    validate: (payload: ValidateRequest): Promise<ValidateResponse> =>
      requests.post<ValidateResponse>(routes.brandUsers.validate, payload),
  },
  brands: {
    list: (listParams: number) => {
      let queryParams = listParams ? `?page=${listParams}` : '';
      return requests.get<ListResponseBrands>(
        `${routes.brandUsers.brands}${queryParams}`
      );
    },
  },
};

export type {
  CreateResponse,
  ListResponse,
  ResponseData,
  CreateRequest,
  ErrorResponse,
  ChangePermissionsRequest,
  ListPayload,
  ValidateSignupTokenRequest,
  ValidateSignupTokenResponse,
  ListResponseBrands,
  ResponseBrands,
  ValidateRequest,
  ValidateResponse,
  PendingSignupRequest,
  PendingSignupResponse,
};

export { ROLES, PENDING_SIGNUP_STATUS };
